module.exports = __webpack_public_path__ + "img/9788960510876.d433039f.jpg";